<template>
  <div
    v-if="tables.length"
    :class="`as-parent-standing as-parent-standing-${siteName}`"
    ref="standingRef"
  >
    <div
      class="as-standing__top"
      :class="{
        'as-standing__tabs-center': hideShowFull,
      }"
    >
      <TabsBtn :tabs="tabs" :activeTab="activeTab" @change="changeTab" />
      <div
        v-if="!hideShowFull"
        class="as-menu"
        :class="{
          'as-active': isShowFull,
        }"
        @click="handleShowFull"
      >
        <IconMenu />
      </div>
    </div>

    <div
      class="as-standing"
      :class="{
        'as-show-full': isShowFull,
        'as-scrolling as-scrolling__have-tab as-scrolling__result-popup':
          isPopup,
      }"
    >
      <div class="as-standing__table">
        <template v-for="(table, key) in tables" :key="key">
          <div class="as-standing__table-row as-standing__table-row-head">
            <div
              v-for="column in columns"
              :key="column.name"
              @click="sortData(column.name)"
              :class="`as-standing__table-column ${column.class}`"
              type="button"
            >
              {{ column.name === "team_name" ? getGroupName(table) : column.title }}

              <IconArrownDown
                v-if="sort.column === column.name"
                class="as-d-inline-flex"
                :class="{
                  'as-sort-down': sort.type === 'ASC',
                  'as-sort-up': sort.type === 'DESC',
                }"
              />
            </div>
            <div
              class="as-standing__table-column as-column-performance as-text-center as-coulumn-show-full"
            >
              Phong độ
              <svg
                width="23"
                height="10"
                viewBox="0 0 23 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_2793_18912)">
                  <path
                    d="M22.7365 5.27651C22.7362 5.27662 22.736 5.27676 22.7357 5.27688L18.0412 7.30813C17.6895 7.4603 17.1206 7.45973 16.7705 7.3068C16.4205 7.15389 16.4219 6.90656 16.7736 6.75438L19.9255 5.39063L0.898438 5.39063C0.402231 5.39063 9.64331e-08 5.21574 1.05863e-07 5C1.15294e-07 4.78426 0.402231 4.60938 0.898438 4.60938L19.9254 4.60938L16.7736 3.24563C16.4219 3.09344 16.4206 2.84612 16.7706 2.69321C17.1207 2.54026 17.6896 2.53973 18.0412 2.69188L22.7357 4.72313C22.736 4.72325 22.7362 4.72338 22.7365 4.7235C23.0884 4.87619 23.0873 5.12432 22.7365 5.27651Z"
                    fill="#00B242"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_2793_18912">
                    <rect
                      width="23"
                      height="10"
                      fill="white"
                      transform="matrix(1 4.37114e-08 4.37114e-08 -1 0 10)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <div
              ref="activeItems"
              class="as-standing__table-column as-scroll-item-active as-column-next as-text-center as-coulumn-show-full"
            >
              Tiếp
            </div>
          </div>
          <div
            v-for="(row, keyRow) in getRows(table.rows)"
            :key="keyRow"
            class="as-standing__table-row"
            :class="{
              active:
                match?.home_team_id === row.team_id ||
                match?.away_team_id === row.team_id,
            }"
          >
            <div
              class="as-standing__table-column as-standing__table-column-stt as-text-center"
              :class="{
                'as-stt-popup': isPopup,
              }"
            >
              <div class="as-stt" :style="getStyleStt(row.promotion_id)">
                {{ row.position }}
              </div>
            </div>
            <div
              class="as-standing__table-column as-standing__table-column-team"
              :class="{
                'as-team-popup': isPopup,
              }"
            >
              <div
                @click="getLinkTeamDetail(row.team_id, row.team_name, true)"
                class="as-match__team-group"
                :class="{
                  'as-match__team-group-live': row.live_score
                }"
              >
                <div class="as-match__team">
                  <img
                    :src="getImgUrlBySport('team', row.team_id)"
                    class="as-match__team-logo"
                    :alt="row.team_name"
                  />
                  <span class="as-standing__table-text">{{ row.team_name }}</span>
                </div>
                <StandingLiveScore v-if="row.live_score" :standing="row" />
              </div>
            </div>
            <div class="as-standing__table-column as-text-center">
              {{ getRowdata(row, "total") }}
            </div>
            <div class="as-standing__table-column as-text-center">
              {{ getRowdata(row, "won") }}
            </div>
            <div class="as-standing__table-column as-text-center">
              {{ getRowdata(row, "draw") }}
            </div>
            <div class="as-standing__table-column as-text-center">
              {{ getRowdata(row, "loss") }}
            </div>
            <div
              class="as-standing__table-column as-text-center as-coulumn-show-full"
            >
              {{ getRowdata(row, "goals") }}:{{
                getRowdata(row, "goals_against")
              }}
            </div>
            <div
              class="as-standing__table-column as-text-center as-c-hsbt as-coulumn-show-full"
            >
              {{ getRowdata(row, "goal_diff") }}
            </div>
            <div class="as-standing__table-column as-text-center">
              {{ getRowdata(row, "points") }}
            </div>
            <div
              class="as-standing__table-column as-text-center as-coulumn-show-full"
            >
              <div class="as-standing-tag__list">
                <button
                  v-for="(recent, keyRecent) in getRecent(row)"
                  :key="keyRecent"
                  :class="`as-standing-tag as-standing-tag__${determineMatchResult(
                    recent,
                    row.team_id
                  ).charAt(0)}`"
                  :title="getRecentTitle(recent)"
                >
                  {{ determineMatchResult(recent, row.team_id).charAt(0) }}
                </button>
              </div>
            </div>
            <div
              class="as-standing__table-column as-text-center as-coulumn-show-full"
            >
              <img
                v-if="row.next_match"
                :src="
                  getImgUrlBySport(
                    'team',
                    row.next_match.away_team?.id === row.team_id
                      ? row.next_match.home_team?.id
                      : row.next_match.away_team?.id
                  )
                "
                class="as-match__team-logo"
                :alt="
                  row.next_match.away_team?.id === row.team_id
                    ? row.next_match.home_team?.name
                    : row.next_match.away_team?.name
                "
                :title="
                  row.next_match.away_team?.id === row.team_id
                    ? row.next_match.home_team?.name
                    : row.next_match.away_team?.name
                "
              />
            </div>
          </div>
        </template>
      </div>

      <div v-if="promotions && promotions.length" class="as-promotion">
        <div
          v-for="(promotion, key) in promotions"
          :key="key"
          class="as-promotion-item"
        >
          <div
            class="as-promotion-circle"
            :style="{
              background: promotion.color,
            }"
          ></div>
          {{ promotion.name }}
        </div>
      </div>
    </div>
  </div>
  <NoData v-else />
</template>

<script setup lang="ts">
import { defineProps, ref, computed, nextTick, onMounted } from "vue";
import IconArrownDown from "~src/components/icons/IconArrownDown.vue";
import IconMenu from "~src/components/icons/IconMenu.vue";
import NoData from "~src/components/NoData.vue";
import TabsBtn from "~src/components/TabsBtn.vue";
import StandingLiveScore from "~src/components/standings/StandingLiveScore.vue";
import { usecommonStore } from "~src/stores/CommonStore";
import type {
  IStanding,
  IMatch,
  ITeam,
  IStandingsRow,
  IStandingsTable,
  IPromotion,
  IRecent,
} from "~src/interfaces";
import { formatLocalTime } from "~src/helpers/CommonHelper";
import {
  determineMatchResult,
  getTeamName,
} from "~src/helpers";
const commonStore = usecommonStore();

interface IProps {
  standing: IStanding;
  match?: IMatch;
  isPopup?: boolean;
  isShowFull?: boolean;
  hideShowFull?: boolean;
}

const props = withDefaults(defineProps<IProps>(), {
  isPopup: true,
  isShowFull: false,
  hideShowFull: false,
});

const siteName = computed(() => commonStore.getSiteName);
const isShowFull = ref(props.isShowFull);
const activeTab = ref("all");
const tabs = ref([
  {
    title: "Tất cả",
    key: "all",
  },
  {
    title: "Sân nhà",
    key: "home",
  },
  {
    title: "Sân khách",
    key: "away",
  },
]);

const columns = [
  {
    title: "#",
    name: "position",
    class: "as-text-center as-standing__table-column-stt as-column-head",
  },
  {
    title: "Đội bóng",
    name: "team_name",
    class: "as-standing__table-column-team as-column-head",
  },
  {
    title: "Trận",
    name: "total",
    class: "as-text-center as-c-total",
  },
  {
    title: "W",
    name: "won",
    class: "as-text-center as-c-w",
  },
  {
    title: "D",
    name: "draw",
    class: "as-text-center as-c-d",
  },
  {
    title: "L",
    name: "loss",
    class: "as-text-center as-c-l",
  },
  {
    title: "G",
    name: "goals",
    class: "as-text-center as-c-g as-coulumn-show-full",
  },
  {
    title: "HSBT",
    name: "goal_diff",
    class: "as-text-center as-c-hsbt as-coulumn-show-full",
  },
  {
    title: "Điểm",
    name: "points",
    class: "as-text-center as-c-point",
  },
];

const sort = ref({
  column: "",
  type: "ASC",
});

const promotions = computed(() => {
  return props.standing.standings.promotions;
});

const tables = computed(() => {
  if (!props.standing?.standings) {
    return [];
  }

  const datas = [];
  for (const table of props.standing.standings.tables) {
    const rows = [];
    for (const row of table.rows) {
      rows.push({
        ...row,
        team_name: getTeamName(props.standing.teams, row.team_id),
      });
    }
    datas.push({
      ...table,
      rows,
    });
  }

  return datas;
});

const getRows = (rows: Array<IStandingsRow>) => {
  return rows?.sort((a: any, b: any) => {
    if (activeTab.value === "all") {
      // chọn sắp xếp
      if (sort.value.column) {
        // sắp xếp string
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return a[sort.value.column] - b[sort.value.column];
          } else {
            return b[sort.value.column] - a[sort.value.column];
          }
        }
      } else {
        return a.position - b.position;
      }
    } else {
      if (sort.value.column) {
        if (sort.value.column === "team_name") {
          if (sort.value.type === "DESC") {
            return a.team_name.localeCompare(b.team_name);
          } else {
            return b.team_name.localeCompare(a.team_name);
          }
        } else {
          if (sort.value.type === "DESC") {
            return (
              a[`${activeTab.value}_${sort.value.column}`] -
              b[`${activeTab.value}_${sort.value.column}`]
            );
          } else {
            return (
              b[`${activeTab.value}_${sort.value.column}`] -
              a[`${activeTab.value}_${sort.value.column}`]
            );
          }
        }
      } else {
        return (
          a[`${activeTab.value}_position`] - b[`${activeTab.value}_position`]
        );
      }
    }
  });
};

const changeTab = (val: string) => {
  activeTab.value = val;
};

const sortData = (columnName: string) => {
  let type = "ASC";
  if (sort.value.column === columnName) {
    if (sort.value.type === "ASC") {
      type = "DESC";
    }
  }
  sort.value = {
    column: columnName,
    type: type,
  };
};

const getContrastColor = (hexcolor: string) => {
  // Remove the hash if it's there
  hexcolor = hexcolor.replace("#", "");
  if (hexcolor === "") return "white";

  // Parse r, g, b values
  let r = parseInt(hexcolor.substring(0, 2), 16); // hex to integer
  let g = parseInt(hexcolor.substring(2, 4), 16);
  let b = parseInt(hexcolor.substring(4, 6), 16);

  // Determine the brightness of the background
  let brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // If brightness is under 128, return white, otherwise return black
  return brightness < 128 ? "white" : "black";
};

const getStyleStt = (promotion_id: string) => {
  const promotion = props.standing.standings.promotions.find(
    (item: IPromotion) => item.id == promotion_id
  );

  if (promotion) {
    return {
      backgroundColor: promotion.color,
      color: getContrastColor(promotion.color),
      fontWeight: 700,
    };
  }

  return {};
};

const getGroupName = (table: IStandingsTable) => {
  if (tables.value.length === 1) {
    return "Đội bóng";
  }

  const groupName = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];

  return `Group ${groupName[table.group - 1]}`;
};

const getRowdata = (row: IStandingsRow, field: string) => {
  if (field === "total") {
    if (activeTab.value === "all") {
      return row.total;
    } else if (activeTab.value === "home") {
      return row.home_total;
    } else {
      return row.away_total;
    }
  } else if (field === "won") {
    if (activeTab.value === "all") {
      return row.won;
    } else if (activeTab.value === "home") {
      return row.home_won;
    } else {
      return row.away_won;
    }
  } else if (field === "draw") {
    if (activeTab.value === "all") {
      return row.draw;
    } else if (activeTab.value === "home") {
      return row.home_draw;
    } else {
      return row.away_draw;
    }
  } else if (field === "loss") {
    if (activeTab.value === "all") {
      return row.loss;
    } else if (activeTab.value === "home") {
      return row.home_loss;
    } else {
      return row.away_loss;
    }
  } else if (field === "goals") {
    if (activeTab.value === "all") {
      return row.goals;
    } else if (activeTab.value === "home") {
      return row.home_goals;
    } else {
      return row.away_goals;
    }
  } else if (field === "goals_against") {
    if (activeTab.value === "all") {
      return row.goals_against;
    } else if (activeTab.value === "home") {
      return row.home_goals_against;
    } else {
      return row.away_goals_against;
    }
  } else if (field === "goal_diff") {
    if (activeTab.value === "all") {
      return row.goal_diff;
    } else if (activeTab.value === "home") {
      return row.home_goal_diff;
    } else {
      return row.away_goal_diff;
    }
  } else if (field === "points") {
    if (activeTab.value === "all") {
      return row.points;
    } else if (activeTab.value === "home") {
      return row.home_points;
    } else {
      return row.away_points;
    }
  }
};

const getRecentTitle = (recent: IRecent) => {
  return `${recent.home_scores[0]}:${recent.away_scores[0]} (${
    recent.home_team?.name
  } - ${recent.away_team?.name}) ${formatLocalTime(recent.match_time)}`;
};

const getRecent = (row: any) => {
  if (activeTab.value === "all") {
    return row.recent_matches;
  } else {
    return row[`${activeTab.value}_matches`];
  }
};

const activeItems = ref<HTMLDivElement | null>(null);
const standingRef = ref<HTMLDivElement | null>(null);

const scrollToActiveItem = (container: HTMLDivElement, activeItem: HTMLDivElement) => {
  try {
    if (!container || !activeItem) return;

    const containerRect = container.getBoundingClientRect();
    const activeItemRect = activeItem.getBoundingClientRect();

    const scrollLeft = container.scrollLeft + activeItemRect.left - containerRect.left;

    container.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  } catch (error) {
    console.error('Error in scrollToActiveItem:', error);
  }
}

const handleShowFull = async () => {
  isShowFull.value = !isShowFull.value;
  await nextTick();

  if (!standingRef.value || !isShowFull.value) return;

  const _tables = standingRef.value.querySelectorAll<HTMLDivElement>(".as-standing__table") ?? [];
  if (!_tables?.length) return;

  Array.from(_tables).forEach((table) => {
    try {
      const activeItem = table.querySelector<HTMLDivElement>(".as-scroll-item-active");
      if (!activeItem) return;

      requestAnimationFrame(() => {
        setTimeout(() => {
          scrollToActiveItem(table, activeItem);
        }, 100);
      });
    } catch (error) {
      console.error('Error scrolling to active item:', error);
    }
  });
};
</script>

<script lang="ts">
export default {};
</script>
